import { useState, useEffect } from 'react'
import { projectFirestore } from '../firebase/config'

const useFirestore = (collection) => {

    const [docs, setDocs] = useState([]);

    useEffect(() => {
        // نجلب كل المستندات بدون orderBy حتى لا يتم استبعاد المستندات التي ليس لها حقل order
        const unsub = projectFirestore.collection(collection)
            .onSnapshot((snap) => {
                let documents = [];
                snap.forEach(doc => {
                    documents.push({ ...doc.data(), id: doc.id });
                });
                // ترتيب محلي: حسب order (تنازلي) ثم createdAt (تنازلي)
                documents.sort((a, b) => {
                    const aOrder = a.order ?? 0;
                    const bOrder = b.order ?? 0;
                    if (aOrder !== bOrder) return bOrder - aOrder;
                    const aTime = a.createdAt?.seconds ?? 0;
                    const bTime = b.createdAt?.seconds ?? 0;
                    return bTime - aTime;
                });
                setDocs(documents);
            });
        return () => unsub();
    }, [collection])

    return {docs};
}

export default useFirestore
